// Function to close the popup and set cookie/local storage
  function closeKlaviyoPopup() {
    document.getElementById('klaviyo-popup').style.display = 'none';
    localStorage.setItem('klaviyoClosed', 'true'); // Store in local storage
    // Set cookie with expiry in 30 days
    var expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 30);
    document.cookie = 'klaviyoClosed=true; expires=' + expiryDate.toUTCString() + '; path=/';
  }

  // Check if the popup should be displayed based on cookie/local storage
  document.addEventListener("DOMContentLoaded", function() {
    if (!localStorage.getItem('klaviyoClosed') || localStorage.getItem('klaviyoClosed') !== 'true') {
      document.getElementById('klaviyo-popup').style.display = 'flex'; // Show the popup
    }
  });

  // Close the popup when clicking outside its content
  window.addEventListener("click", function(event) {
    var popup = document.getElementById('klaviyo-popup');
    if (event.target === popup) {
      closeKlaviyoPopup();
    }
  });

// Show the popup after a delay
    setTimeout(function() {
        popup.style.display = 'block';
    }, 3000); // Show after 3 seconds

  document.getElementById('klaviyo-form').addEventListener('submit', function(event) {
    event.preventDefault();

    var form = event.target;
    var formData = new FormData(form);

    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe', true);

    xhr.onload = function() {
      var response = JSON.parse(xhr.responseText);
      var messageDiv = document.getElementById('response-message');

      if (response.success) {
        if (response.data.is_subscribed) {
          messageDiv.innerHTML = 'Please check your email to confirm the subscription.';
          messageDiv.style.color = 'green';

          // Apply tag after successful subscription
          applyKlaviyoTag(response.data.email, 'website_launch'); // Replace 'YourTagID' with your actual tag ID
        } else {
          messageDiv.innerHTML = 'You are already subscribed.';
          messageDiv.style.color = 'blue';
        }
      } else {
        messageDiv.innerHTML = 'There was an error: ' + response.errors.join(', ');
        messageDiv.style.color = 'red';
      }
    };

    xhr.send(formData);
  });

  // Function to apply tag using Klaviyo API
  function applyKlaviyoTag(email, website_launch) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://a.klaviyo.com/api/v2/list/RNAe5g/subscribe', true); // Replace 'YOUR_LIST_ID' with your actual list ID
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        console.log('Tag applied successfully');
      }
    };

    var data = JSON.stringify({
      profiles: [{ email: email }],
      properties: { $add: [tagID] }
    });

    xhr.send(data);
  }